import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AdminLayout from '../components/layout/AdminLayout';
import CustomerLayout from '../components/layout/CustomerLayout';
import MechanicLayout from '../components/layout/MechanicLayout';
import TelecallerLayout from '../components/layout/TelecallerLayout';
import TeamLeadLayout from '../components/layout/TeamLeadLayout';
import ServiceAdvisorLayout from '../components/layout/ServiceAdvisorLayout';
import ServiceExecutiveLayout from '../components/layout/ServiceExecutiveLayout';
import SupervisorLayout from '../components/layout/SupervisorLayout';
import TLManagerLayout from '../components/layout/TLManagerLayout';
import CourierManagerLayout from '../components/layout/CourierManagerLayout';
import PartnerLayout from '../components/layout/PartnerLayout';

// Admin Pages
import Dashboard from '../pages/admin/Dashboard';
import Users from '../pages/admin/Users';
import CustomerDetail from '../pages/admin/CustomerDetail';
import SalesReport from '../pages/admin/SalesReport';
import ServiceReport from '../pages/admin/ServiceReport';
import AdminCallReport from '../pages/admin/CallReport';
import Settings from '../pages/admin/Settings';
import Notifications from '../pages/admin/Notifications';
import MoreOptions from '../pages/admin/MoreOptions';
import Complaints from '../pages/admin/Complaints';
import ComplaintDetails from '../pages/admin/ComplaintDetails';
import PopularServices from '../pages/admin/PopularServices';
import CustomerAppBanners from '../pages/admin/CustomerAppBanners';
import MechanicAppBanners from '../pages/admin/MechanicAppBanners';
import PartnerTraining from '../pages/admin/PartnerTraining';
import MembershipPlansAdmin from '../pages/admin/MembershipPlansAdmin';
import TeamLeaders from '../pages/admin/TeamLeaders';
import ShipmentTracking from '../pages/admin/ShipmentTracking';
import LeadsCSVUpload from '../pages/admin/LeadsCSVUpload';
import WFHLeadsCSVUpload from '../pages/admin/WFHLeadsCSVUpload';
import WFHEmployeeReport from '../pages/admin/WFHEmployeeReport';
import WFHTelecallerDetailReport from '../pages/admin/WFHTelecallerDetailReport';
import WFHDashboard from '../pages/admin/WFHDashboard';
import MechanicCSVUpload from '../pages/admin/MechanicCSVUpload';
import MechanicManagement from '../pages/admin/MechanicManagement';
import MechanicKycVerify from '../pages/admin/MechanicKycVerify';
import MechanicAssignmentCities from '../pages/admin/MechanicAssignmentCities';
import PartnerRsaTickets from '../pages/admin/PartnerRsaTickets';
import Enterprises from '../pages/admin/Enterprises';
import EnterpriseInquiries from '../pages/admin/EnterpriseInquiries';
import EnterpriseDetail from '../pages/admin/EnterpriseDetail';
import DeliveredLeads from '../pages/admin/DeliveredLeads';
import PayoutRequests from '../pages/admin/PayoutRequests';
import WhatsApp from '../pages/admin/WhatsApp';
import WhatsAppAutomation from '../pages/admin/WhatsAppAutomation';
import AppEnquiries from '../pages/admin/AppEnquiries';
import AddCustomer from '../pages/admin/AddCustomer';
import PhysicalCardVerifications from '../pages/admin/PhysicalCardVerifications';
import CallProviderSettings from '../pages/admin/CallProviderSettings';
import EmployeeAttendance from '../pages/admin/EmployeeAttendance';
import BlogAdmin from '../pages/admin/BlogAdmin';
import UrlManage from '../pages/admin/UrlManage';
import Coupons from '../pages/admin/Coupons';
import FaultDetector from '../pages/admin/FaultDetector';
import AppVersionControl from '../pages/admin/AppVersionControl';
import GoogleBusinessPosts from '../pages/admin/GoogleBusinessPosts';

// Customer Pages
import CustomerDashboard from '../pages/customer/Dashboard';
import CustomerServices from '../pages/customer/Services';
import CustomerVehicles from '../pages/customer/Vehicles';
import CustomerChat from '../pages/customer/Chat';
import CustomerProfile from '../pages/customer/Profile';
import PeriodicService from '../pages/customer/PeriodicService';
import Offers from '../pages/customer/Offers';
import Track from '../pages/customer/Track';
import Support from '../pages/customer/Support';
import ServiceHistory from '../pages/customer/ServiceHistory';
import PaymentHistory from '../pages/customer/PaymentHistory';

// Shared Pages
import OrderDetails from '../pages/shared/OrderDetails';

// Mechanic Pages
import MechanicDashboard from '../pages/mechanic/Dashboard';
import MechanicRequests from '../pages/mechanic/Requests';
import MechanicChat from '../pages/mechanic/Chat';
import MechanicProfile from '../pages/mechanic/Profile';

// Telecaller Pages
import TelecallerDashboard from '../pages/telecaller/Dashboard';
import { TelecallerDialer, TelecallerLeadsHistory, TelecallerConfirmation, TelecallerBooked, TelecallerMore } from '../pages/telecaller';
import TelecallerProfile from '../pages/telecaller/Profile';
import TelecallerSettings from '../pages/telecaller/Settings';
import TelecallerPerformance from '../pages/telecaller/Performance';
import CallRecordings from '../pages/telecaller/CallRecordings';
import TelecallerHelpSupport from '../pages/telecaller/HelpSupport';
import AssignedLeads from '../pages/telecaller/AssignedLeads';
import NotAnswer from '../pages/telecaller/NotAnswer';
import NotInterested from '../pages/telecaller/NotInterested';
import WFHDialer from '../pages/telecaller/WFHDialer';

// Team Lead Pages
import TeamLeadDashboard from '../pages/teamlead/Dashboard';
import { TeamLeadLeadDistribution, TeamLeadLeadConfirmation, TeamLeadPerformance, TeamLeadBooked, TeamLeadMore } from '../pages/teamlead';
import TeamLeadProfile from '../pages/teamlead/Profile';
import TeamLeadSettings from '../pages/teamlead/Settings';
import TeamLeadHelpSupport from '../pages/teamlead/HelpSupport';
import TeamManagement from '../pages/teamlead/TeamManagement';
import LeadAnalytics from '../pages/teamlead/LeadAnalytics';
import AttendanceManagement from '../pages/teamlead/AttendanceManagement';
import CourierBooking from '../pages/teamlead/CourierBooking';
import DeliveredCustomers from '../pages/teamlead/DeliveredCustomers';

// Service Advisor Pages
import ServiceAdvisorDashboard from '../pages/service_advisor/Dashboard';
import { ServiceAdvisorComplaints, ServiceAdvisorRegistered, ServiceAdvisorMechanics } from '../pages/service_advisor';
import ComplaintDetail from '../pages/service_advisor/ComplaintDetail';
import AssignmentDetails from '../pages/service_advisor/AssignmentDetails';
import AssignMechanic from '../pages/service_advisor/AssignMechanic';
import MechanicLogs from '../pages/service_advisor/MechanicLogs';
import ComplaintRegistration from '../pages/service_advisor/ComplaintRegistration';
import MembershipCustomer from '../pages/service_advisor/MembershipCustomer';
import CallReport from '../pages/service_advisor/CallReport';

// Service Executive Pages
import ServiceExecutiveDashboard from '../pages/service_executive/Dashboard';
import { ServiceExecutiveComplaints, ServiceExecutiveOrders } from '../pages/service_executive';

// Supervisor Pages
import SupervisorDashboard from '../pages/supervisor/Dashboard';
import { SupervisorOperations, SupervisorReports } from '../pages/supervisor';

// TL Manager Pages
import TLManagerDashboard from '../pages/tl_manager/Dashboard';
import { TLManagerPerformance, TLManagerPaymentVerification, TLManagerBooked } from '../pages/tl_manager';

// Courier Manager Pages
import CourierManagerDashboard from '../pages/courier_manager/Dashboard';
import { CourierManagerShipmentTracking, CourierManagerOrders } from '../pages/courier_manager';

// Partner Pages
import PartnerDashboard from '../pages/partner/Dashboard';
import { PartnerOrders, PartnerRevenue } from '../pages/partner';

export const RoleRouter = ({ user, onLogout }) => {
  const location = useLocation();
  let primaryRole = user?.primaryRole || user?.currentRole || 'customer';
  
  // Normalize role name (handle both serviceadvisor and service_advisor)
  if (primaryRole === 'serviceadvisor') {
    primaryRole = 'service_advisor';
  }
  if (primaryRole === 'serviceexecutive') {
    primaryRole = 'service_executive';
  }
  
  // Admin Routes (no prefix)
  if (primaryRole === 'admin') {
    return (
      <AdminLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/:userId" element={<CustomerDetail />} />
          <Route path="/sales-report" element={<SalesReport />} />
          <Route path="/service-report" element={<ServiceReport />} />
          <Route path="/call-report" element={<AdminCallReport />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/more" element={<MoreOptions />} />
          <Route path="/complaints" element={<Complaints />} />
          <Route path="/complaints/:id" element={<ComplaintDetails />} />
          {/* Admin shortcut: open full Service Advisor complaint detail UI (used by Service Reports "Open in new tab") */}
          <Route path="/service_advisor/complaints/:id" element={<ComplaintDetail />} />
          <Route path="/service_advisor/complaints/:complaintId/logs" element={<MechanicLogs />} />
          <Route path="/service_advisor/assign-mechanic/:id" element={<AssignMechanic />} />
          <Route path="/service_advisor/assignment-details/:id" element={<AssignmentDetails />} />
          <Route path="/popular-services" element={<PopularServices />} />
          <Route path="/customer-app-banners" element={<CustomerAppBanners />} />
          <Route path="/mechanic-app-banners" element={<MechanicAppBanners />} />
          <Route path="/partner-training" element={<PartnerTraining />} />
          <Route path="/membership-plans" element={<MembershipPlansAdmin />} />
          <Route path="/team-leaders" element={<TeamLeaders />} />
          <Route path="/shipment-tracking" element={<ShipmentTracking />} />
          <Route path="/leads-csv-upload" element={<LeadsCSVUpload />} />
          <Route path="/wfh-leads-csv-upload" element={<WFHLeadsCSVUpload />} />
          <Route path="/wfh-employee-report" element={<WFHEmployeeReport />} />
          <Route path="/wfh-employee-report/telecaller/:telecallerId" element={<WFHTelecallerDetailReport />} />
          <Route path="/wfh-dashboard" element={<WFHDashboard />} />
          <Route path="/mechanic-csv-upload" element={<MechanicCSVUpload />} />
          <Route path="/mechanic-management" element={<MechanicManagement />} />
          <Route path="/mechanic-kyc" element={<MechanicKycVerify />} />
          <Route path="/mechanic-assignment-cities" element={<MechanicAssignmentCities />} />
          <Route path="/partner-rsa-tickets" element={<PartnerRsaTickets />} />
          <Route path="/enterprises" element={<Enterprises />} />
          <Route path="/enterprises/inquiries" element={<EnterpriseInquiries />} />
          <Route path="/enterprises/:id" element={<EnterpriseDetail />} />
          <Route path="/delivered-leads" element={<DeliveredLeads />} />
          <Route path="/payout-requests" element={<PayoutRequests />} />
          <Route path="/whatsapp" element={<WhatsApp />} />
          <Route path="/whatsapp-automation" element={<WhatsAppAutomation />} />
          <Route path="/app-enquiries" element={<AppEnquiries />} />
          <Route path="/add-customer" element={<AddCustomer />} />
          <Route path="/physical-card-verifications" element={<PhysicalCardVerifications />} />
          <Route path="/call-provider-settings" element={<CallProviderSettings />} />
          <Route path="/employee-attendance" element={<EmployeeAttendance />} />
          <Route path="/blog-admin" element={<BlogAdmin />} />
          <Route path="/url-manage" element={<UrlManage />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route path="/fault-detector" element={<FaultDetector />} />
          <Route path="/app-version-control" element={<AppVersionControl />} />
          <Route path="/google-business-posts" element={<GoogleBusinessPosts />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AdminLayout>
    );
  }

  // Customer Routes
  if (primaryRole === 'customer') {
    return (
      <CustomerLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/customer/dashboard" element={<CustomerDashboard />} />
          <Route path="/customer/services" element={<CustomerServices />} />
          <Route path="/customer/services/periodic" element={<PeriodicService />} />
          <Route path="/customer/vehicles" element={<CustomerVehicles />} />
          <Route path="/customer/chat" element={<CustomerChat />} />
          <Route path="/customer/profile" element={<CustomerProfile />} />
          <Route path="/customer/offers" element={<Offers />} />
          <Route path="/customer/track" element={<Track />} />
          <Route path="/customer/support" element={<Support />} />
          <Route path="/customer/service-history" element={<ServiceHistory />} />
          <Route path="/customer/payment-history" element={<PaymentHistory />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
          <Route path="/customer" element={<Navigate to="/customer/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/customer/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/customer/dashboard" replace />} />
        </Routes>
      </CustomerLayout>
    );
  }

  // Mechanic Routes
  if (primaryRole === 'mechanic') {
    return (
      <MechanicLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/mechanic/dashboard" element={<MechanicDashboard />} />
          <Route path="/mechanic/requests" element={<MechanicRequests />} />
          <Route path="/mechanic/chat" element={<MechanicChat />} />
          <Route path="/mechanic/profile" element={<MechanicProfile />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
          <Route path="/mechanic" element={<Navigate to="/mechanic/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/mechanic/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/mechanic/dashboard" replace />} />
        </Routes>
      </MechanicLayout>
    );
  }

  // Telecaller Routes
  if (primaryRole === 'telecaller') {
    return (
      <TelecallerLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/telecaller/dashboard" element={<TelecallerDashboard />} />
          <Route path="/telecaller/dialer" element={<TelecallerDialer />} />
          <Route path="/telecaller/wfh" element={<WFHDialer />} />
          <Route path="/telecaller/leads-history" element={<TelecallerLeadsHistory />} />
          <Route path="/telecaller/confirmation" element={<TelecallerConfirmation />} />
          <Route path="/telecaller/booked" element={<TelecallerBooked />} />
          <Route path="/telecaller/more" element={<TelecallerMore />} />
          <Route path="/telecaller/profile" element={<TelecallerProfile />} />
          <Route path="/telecaller/settings" element={<TelecallerSettings />} />
          <Route path="/telecaller/performance" element={<TelecallerPerformance />} />
          <Route path="/telecaller/call-recordings" element={<CallRecordings />} />
          <Route path="/telecaller/help" element={<TelecallerHelpSupport />} />
          <Route path="/telecaller/assigned-leads" element={<AssignedLeads />} />
          <Route path="/telecaller/not-answer" element={<NotAnswer />} />
          <Route path="/telecaller/not-interested" element={<NotInterested />} />
          <Route path="/telecaller" element={<Navigate to="/telecaller/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/telecaller/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/telecaller/dashboard" replace />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
        </Routes>
      </TelecallerLayout>
    );
  }

  // Team Lead Routes
  if (primaryRole === 'teamlead') {
    return (
      <TeamLeadLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/teamlead/dashboard" element={<TeamLeadDashboard />} />
          <Route path="/teamlead/lead-distribution" element={<TeamLeadLeadDistribution />} />
          <Route path="/teamlead/lead-confirmation" element={<TeamLeadLeadConfirmation />} />
          <Route path="/teamlead/performance" element={<TeamLeadPerformance />} />
          <Route path="/teamlead/booked" element={<TeamLeadBooked />} />
          <Route path="/teamlead/more" element={<TeamLeadMore />} />
          <Route path="/teamlead/profile" element={<TeamLeadProfile />} />
          <Route path="/teamlead/settings" element={<TeamLeadSettings />} />
          <Route path="/teamlead/help" element={<TeamLeadHelpSupport />} />
          <Route path="/teamlead/team-management" element={<TeamManagement />} />
          <Route path="/teamlead/lead-analytics" element={<LeadAnalytics />} />
          <Route path="/teamlead/attendance" element={<AttendanceManagement />} />
          <Route path="/teamlead/courier-booking" element={<CourierBooking />} />
          <Route path="/teamlead/delivered-customers" element={<DeliveredCustomers />} />
          <Route path="/teamlead" element={<Navigate to="/teamlead/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/teamlead/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/teamlead/dashboard" replace />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
        </Routes>
      </TeamLeadLayout>
    );
  }

  // Service Advisor Routes (handle both serviceadvisor and service_advisor)
  if (primaryRole === 'service_advisor' || primaryRole === 'serviceadvisor') {
    return (
      <ServiceAdvisorLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/service_advisor/dashboard" element={<ServiceAdvisorDashboard />} />
          <Route path="/service_advisor/complaints" element={<ServiceAdvisorComplaints />} />
          <Route path="/service_advisor/complaints/:id" element={<ComplaintDetail />} />
          <Route path="/service_advisor/assign-mechanic/:id" element={<AssignMechanic />} />
          <Route path="/service_advisor/assignment-details/:id" element={<AssignmentDetails />} />
          <Route path="/service_advisor/mechanics" element={<ServiceAdvisorMechanics />} />
          <Route path="/service_advisor/mechanics/:mechanicId/logs" element={<MechanicLogs />} />
          <Route path="/service_advisor/complaints/:complaintId/logs" element={<MechanicLogs />} />
          <Route path="/service_advisor/registered" element={<ServiceAdvisorRegistered />} />
          <Route path="/service_advisor/complaint-registration" element={<ComplaintRegistration />} />
          <Route path="/service_advisor/membership-customer" element={<MembershipCustomer />} />
          <Route path="/service_advisor/call-report" element={<CallReport />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
          <Route path="/service_advisor" element={<Navigate to="/service_advisor/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/service_advisor/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/service_advisor/dashboard" replace />} />
        </Routes>
      </ServiceAdvisorLayout>
    );
  }

  // Service Executive Routes
  if (primaryRole === 'service_executive') {
    return (
      <ServiceExecutiveLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/service_executive/dashboard" element={<ServiceExecutiveDashboard />} />
          <Route path="/service_executive/complaints" element={<ServiceExecutiveComplaints />} />
          <Route path="/service_executive/orders" element={<ServiceExecutiveOrders />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
          <Route path="/service_executive" element={<Navigate to="/service_executive/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/service_executive/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/service_executive/dashboard" replace />} />
        </Routes>
      </ServiceExecutiveLayout>
    );
  }

  // Supervisor Routes
  if (primaryRole === 'supervisor') {
    return (
      <SupervisorLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/supervisor/dashboard" element={<SupervisorDashboard />} />
          <Route path="/supervisor/operations" element={<SupervisorOperations />} />
          <Route path="/supervisor/reports" element={<SupervisorReports />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
          <Route path="/supervisor" element={<Navigate to="/supervisor/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/supervisor/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/supervisor/dashboard" replace />} />
        </Routes>
      </SupervisorLayout>
    );
  }

  // TL Manager Routes
  if (primaryRole === 'tl_manager') {
    return (
      <TLManagerLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/tl_manager/dashboard" element={<TLManagerDashboard />} />
          <Route path="/tl_manager/performance" element={<TLManagerPerformance />} />
          <Route path="/tl_manager/payment-verification" element={<TLManagerPaymentVerification />} />
          <Route path="/tl_manager/booked" element={<TLManagerBooked />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
          <Route path="/tl_manager" element={<Navigate to="/tl_manager/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/tl_manager/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/tl_manager/dashboard" replace />} />
        </Routes>
      </TLManagerLayout>
    );
  }

  // Courier Manager Routes
  if (primaryRole === 'courier_manager') {
    return (
      <CourierManagerLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/courier_manager/dashboard" element={<CourierManagerDashboard />} />
          <Route path="/courier_manager/shipment-tracking" element={<CourierManagerShipmentTracking />} />
          <Route path="/courier_manager/orders" element={<CourierManagerOrders />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
          <Route path="/courier_manager" element={<Navigate to="/courier_manager/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/courier_manager/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/courier_manager/dashboard" replace />} />
        </Routes>
      </CourierManagerLayout>
    );
  }

  // Partner Routes
  if (primaryRole === 'partner') {
    return (
      <PartnerLayout user={user} onLogout={onLogout}>
        <Routes>
          <Route path="/partner/dashboard" element={<PartnerDashboard />} />
          <Route path="/partner/orders" element={<PartnerOrders />} />
          <Route path="/partner/revenue" element={<PartnerRevenue />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
          <Route path="/partner" element={<Navigate to="/partner/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/partner/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/partner/dashboard" replace />} />
        </Routes>
      </PartnerLayout>
    );
  }

  // Default fallback
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Role Not Supported</h1>
        <p className="text-gray-600">Your role ({primaryRole}) is not yet supported in the web app.</p>
        <button
          onClick={onLogout}
          className="mt-4 px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600"
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default RoleRouter;
